//https://loizenai.com/reactjs-jwt-authentication-example/

import axios from 'axios';
import configData from "../config.json";

// Add a request interceptor
//axios.interceptors.request.use(config => {
//    const user = JSON.parse(localStorage.getItem('user'));

//    if (user && user.accessToken) {
//        const token = 'Bearer ' + user.accessToken;
//        config.headers.Authorization = token;
//    }

//    return config;
//});

class ApiServices {
    constructor() {
        // maak een axios instance
        this.apiClient = axios.create({
            baseURL: configData.SERVER_URL,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        // Request interceptor: voegt automatisch het token toe
        this.apiClient.interceptors.request.use(
            (config) => {
                //const user = JSON.parse(localStorage.getItem('user'));
                const accessToken = localStorage.getItem('accessToken');
                if (accessToken) {
                    config.headers.Authorization = `Bearer ${accessToken}`;
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

        // Response interceptor: optioneel, bv. 401 handling
        this.apiClient.interceptors.response.use(
            (response) => response,
            async (error) => {
                const originalRequest = error.config;

                if (error.response?.status === 401 && !originalRequest._retry) {
                    originalRequest._retry = true; // markeer dat we al geprobeerd hebben

                    try {
                        // haal het refresh token uit localStorage
                        const refreshToken = localStorage.getItem('refreshToken');
                        if (!refreshToken)
                            throw new Error('Geen refresh token beschikbaar');

                        // vraag een nieuw access token aan via de API
                        const response = await axios.post(configData.SERVER_URL + 'Account/RefreshToken', {
                            refreshToken: refreshToken
                        });

                        // update localStorage met nieuwe tokens
                        localStorage.setItem('accessToken', response.data.accessToken);
                        localStorage.setItem('refreshToken', response.data.refreshToken);

                        // update de header van het originele verzoek
                        originalRequest.headers.Authorization = `Bearer ${response.data.accessToken}`;

                        // probeer het originele verzoek opnieuw
                        return this.apiClient(originalRequest);
                    } catch (refreshError) {
                        // refresh token is niet geldig: log uit
                        localStorage.removeItem('user');
                        window.location.href = '/login';
                        return Promise.reject(refreshError);
                    }
                }
                return Promise.reject(error);
            }
        );
    }

    /**** Account ****/
    async verifyAccount(userAccountId, verifyToken) {
        return await this.apiClient.post('Account/VerifyAccount', null, {
            params: {
                userAccountId,
                verifyToken
            }
        });
    }

    async login(loginData) {
        return await this.apiClient.post('Account/Login', loginData);
    }

    async getCollections(isMyCollections, currentUser) {
        var apiUrl = 'collections/'

        if (isMyCollections)
            apiUrl += 'GetMyCollections/' + currentUser.userAccountId;
        else if (currentUser)
            apiUrl += 'GetActualCollectionsForUser/' + currentUser.userAccountId;
        else
            apiUrl += 'GetActualCollections';

        const response = await this.apiClient.get(apiUrl);
        return await response.data;

        //const response = await fetch(apiUrl, {
        //    headers: {
        //        'Content-Type': 'application/json'
        //    }
        //});
        //const data = await response.json();

    }


    async addUserAccount(registerData) {
        return await this.apiClient.post('Account/addUserAccount', registerData);
    }

    /**** Collection ****/
    async getCollection(collectionId) {
        const response = await this.apiClient.get( 'Collections/getCollection/' + collectionId);
        return await response.data;
    }

    async getCollectionItems(userAccountId, collectionId) {
        const response = await this.apiClient.get('Collections/getCollectionItems/' + userAccountId + '/' + collectionId);
        return await response.data;
    }

    async setItemOwned(userAccountId, collectionItemId) {

        return await this.apiClient.post('Collections/SetItemOwned', null, {
            params: {
                userAccountId,
                collectionItemId
            }
        });
    }

    async increaseNumberOfItems(userAccountId, collectionItemId) {

        return await this.apiClient.post('Collections/IncreaseNumberOfItems', null, {
            params: {
                userAccountId,
                collectionItemId
            }
        });
    }

    async decreaseNumberOfItems(userAccountId, collectionItemId) {
        return await this.apiClient.post('Collections/DecreaseNumberOfItems', null, {
            params: {
                userAccountId,
                collectionItemId
            }
        });
    }

    async addToMyCollection(userAccountId, collectionId) {
        return await this.apiClient.post('Collections/AddToMyCollection', null, {
            params: {
                userAccountId,
                collectionId
            }
        });
    }

    /**** Trading ****/

    async getMatchTradeUser(userAccountId, collectionId, tradeUserId) {
        const response = await this.apiClient.get('trade/GetMatchTradeUser/' + userAccountId + '/' + tradeUserId + '/' + collectionId);
        return await response.data;
    }

    async makeTradeRequest(tradeRequestData) {
        //return await axios.post(configData.SERVER_URL + 'trade/MakeTradeRequest', tradeRequestData);
        return await this.apiClient.post('trade/MakeTradeRequest', tradeRequestData
            , {
                headers: {
                    'Content-Type': 'application/json'
                },
            })
    }

    async getTradeUsers(userAccountId, collectionId) {
        const response = await this.apiClient.get('trade/GetTradeUsers/' + userAccountId + '/' + collectionId);
        return await response.data;
    }

    async getTradeRequests(userAccountId, collectionId) {
        const response = await this.apiClient.get('trade/GetTradeRequests/' + userAccountId + '/' + collectionId);
        return await response.data;
    }

    async cancelTradeRequest(tradeRequestId) {
        return await this.apiClient.post('trade/CancelTradeRequest', null, {
            params: {
                tradeRequestId
            }
        });
    }

    async approveTradeRequest(tradeRequestId) {
        return await this.apiClient.post('trade/ApproveTradeRequest', null, {
            params: {
                tradeRequestId
            }
        });
    }

    async rejectTradeRequest(tradeRequestId) {
        return await this.apiClient.post('trade/RejectTradeRequest', null, {
            params: {
                tradeRequestId
            }
        });
    }

    async tradeRequestItemSend(tradeRequestId, userAccountId) {
        return await this.apiClient.post('trade/TradeRequestItemSend', null, {
            params: {
                tradeRequestId,
                userAccountId
            }
        });
    }

    async tradeRequestItemReceived(tradeRequestId, userAccountId) {
        return await this.apiClient.post('trade/TradeRequestItemReceived', null, {
            params: {
                tradeRequestId,
                userAccountId
            }
        });
    }

    async getPublicTradeItems(userAccountId, collectionId) {
        const response = await this.apiClient.get('share/GetPublicTradeItems/' + userAccountId + '/' + collectionId);
        return await response.data;
    }
} 

export default new ApiServices();